// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import {Icon, IconName} from '@wandb/weave/components/Icon';
import React, {useContext} from 'react';
import {toast} from 'react-toastify';

import {useRevokeAccessTokenEmailMutation} from '../../generated/graphql';
import {propagateErrorsContext} from '../../util/errors';
import {
  INDIVIDUAL_SHARING_REVOKE_VALUE,
  PermissionDropdown,
} from './PermissionDropdown';
import * as S from './ShareReportTrigger.styles';
import {ShareReportTriggerContext} from './ShareReportTriggerContextProvider';

const PERMISSION_OPTIONS: Array<{
  name?: string;
  value: string;
  icon?: IconName;
  destructive?: boolean;
}> = [
  {
    name: 'Can view',
    value: '',
    icon: 'show-visible',
  },
  {value: 'divider'},
  {
    name: 'Remove access',
    value: INDIVIDUAL_SHARING_REVOKE_VALUE,
    icon: 'delete',
    destructive: true,
  },
];

export const SharedWithIndividualsSection = ({
  openDropdown,
  setOpenDropdown,
}: {
  openDropdown: string;
  setOpenDropdown: (s: string) => void;
}) => {
  const {
    canChangeSharingSettings,
    currentIndividualSharingAccessToken,
    updateViewAccessToken,
    view,
  } = useContext(ShareReportTriggerContext);

  const [revokeAccessTokenEmail] = useRevokeAccessTokenEmailMutation({
    context: propagateErrorsContext(),
  });

  const revokeIndividualAccess = async (email: string) => {
    let result;
    try {
      result = await revokeAccessTokenEmail({
        variables: {
          token: currentIndividualSharingAccessToken!.token,
          email,
        },
      });
    } catch (err) {
      const errorMsg: string =
        (err as any)?.networkError?.result?.errors?.[0]?.message ??
        'An error occurred - please check that the email/username is valid';
      toast(errorMsg);
      return;
    }
    const accessToken = (result?.data as any)?.revokeAccessTokenEmail
      ?.accessToken;
    if (accessToken != null) {
      updateViewAccessToken(accessToken);
      toast(`Unshared with ${email}`);
      window.analytics?.track?.('Report unshared with individual', {
        reportId: view.cid,
        unsharedWithUserEmail: email,
      });
    }
  };

  return (
    <>
      {currentIndividualSharingAccessToken != null &&
        currentIndividualSharingAccessToken.emails.map(email => (
          <S.RowWrapper key={email}>
            <S.IconTextWrapper>
              <S.GrayCircleWBIcon name="user-profile-personal" />
              <S.EmailText title={email}>{email}</S.EmailText>
            </S.IconTextWrapper>
            <S.ShareOptionsWrapper>
              <PermissionDropdown
                onClose={() => setOpenDropdown('')}
                id={email}
                selectedValue=""
                onItemClick={val => {
                  if (val === INDIVIDUAL_SHARING_REVOKE_VALUE) {
                    revokeIndividualAccess(email);
                  }
                }}
                options={PERMISSION_OPTIONS}
                isOpen={openDropdown === email}
                setIsOpen={setOpenDropdown}
                Trigger={
                  <S.Tooltip
                    on="hover"
                    inverted
                    position="top center"
                    size="mini"
                    content={
                      canChangeSharingSettings
                        ? ''
                        : 'Only team admin or author can change access permissions'
                    }
                    hidden={canChangeSharingSettings}
                    trigger={
                      <Button variant="ghost">
                        <S.DropdownTrigger
                          disabled={!canChangeSharingSettings}
                          onClick={() => {
                            if (canChangeSharingSettings) {
                              setOpenDropdown(
                                openDropdown === email ? '' : email
                              );
                            }
                          }}>
                          can view
                          <Icon
                            name={
                              openDropdown === email
                                ? 'chevron-up'
                                : 'chevron-down'
                            }
                          />
                        </S.DropdownTrigger>
                      </Button>
                    }
                  />
                }
              />
            </S.ShareOptionsWrapper>
          </S.RowWrapper>
        ))}
    </>
  );
};
